import { get } from '../utils/api';

export async function getAccessToken() {
  return get(`/user/integrations/googleDrive/token`).then(r => r.data);
}
